"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _moment = _interopRequireDefault(require("moment"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _icons = require("../../icons");

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _Popover = _interopRequireDefault(require("../Popover"));

var _Button = _interopRequireDefault(require("../Button"));

var _YearMenu = _interopRequireDefault(require("./YearMenu"));

var _CalendarTable = _interopRequireDefault(require("./CalendarTable"));

var _TimePicker = _interopRequireDefault(require("./TimePicker"));

var _displayFormats = _interopRequireDefault(require("./utils/displayFormats"));

var _applyExistingTimes = _interopRequireDefault(require("./utils/applyExistingTimes"));

var _isInMinMaxBounds = _interopRequireDefault(require("./utils/isInMinMaxBounds"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DatePicker =
/*#__PURE__*/
function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "populateState", function () {
      _this.setState(function (state) {
        var _this$props = _this.props,
            value = _this$props.value,
            rangedTimes = _this$props.rangedTimes,
            rangedDates = _this$props.rangedDates,
            min = _this$props.min,
            max = _this$props.max;
        var isRanged = rangedTimes || rangedDates;
        var viewDate = state.viewDate;
        var nonRangeSelectedDate = null;
        var rangedStartDate = null;
        var rangedEndDate = null;
        var textInputVal = state.textInputVal;
        var isValid = true;

        if (isRanged) {
          var startProp = (0, _get["default"])(value, 'start', null);
          var endProp = (0, _get["default"])(value, 'end', null);
          rangedStartDate = startProp ? (0, _moment["default"])(startProp) : null;
          rangedEndDate = endProp ? (0, _moment["default"])(endProp) : null;
          var startIsValid = rangedStartDate ? rangedStartDate.isValid() && !rangedStartDate.isAfter(rangedEndDate) : true;
          var endIsValid = rangedEndDate ? rangedEndDate.isValid() && !rangedEndDate.isBefore(rangedStartDate) : true;
          isValid = startIsValid && endIsValid;

          if (isValid && !state.userIsTyping) {
            textInputVal = _this.getDisplayString({
              start: rangedStartDate,
              end: rangedEndDate
            });
            isValid = (0, _isInMinMaxBounds["default"])(rangedStartDate, min, max) && (0, _isInMinMaxBounds["default"])(rangedEndDate, min, max);
          }
        } else {
          nonRangeSelectedDate = value ? (0, _moment["default"])(value) : null;
          if (nonRangeSelectedDate) isValid = nonRangeSelectedDate.isValid();
          if (nonRangeSelectedDate && isValid) viewDate = nonRangeSelectedDate;

          if (isValid && !state.userIsTyping) {
            textInputVal = _this.getDisplayString(nonRangeSelectedDate);
            isValid = (0, _isInMinMaxBounds["default"])(nonRangeSelectedDate, min, max);
          }
        }

        return {
          viewDate: viewDate,
          nonRangeSelectedDate: nonRangeSelectedDate,
          rangedStartDate: rangedStartDate,
          rangedEndDate: rangedEndDate,
          textInputVal: textInputVal,
          isValid: isValid
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getDisplayFormat", function () {
      var enableTimePicker = _this.props.enableTimePicker;
      if (enableTimePicker) return _displayFormats["default"].dateAndTime;
      return _displayFormats["default"].dateOnly;
    });

    _defineProperty(_assertThisInitialized(_this), "getDisplayString", function (value) {
      var _this$props2 = _this.props,
          rangedTimes = _this$props2.rangedTimes,
          rangedDates = _this$props2.rangedDates;
      var dateOnly = _displayFormats["default"].dateOnly,
          timeOnly = _displayFormats["default"].timeOnly;

      var displayFormat = _this.getDisplayFormat();

      var inputValue = '';

      if (rangedTimes) {
        var date = value.start || value.end;

        if (date) {
          var dateStr = date.format(dateOnly);
          var startTimeStr = value.start ? value.start.format(timeOnly) : 'start time';
          var endTimeStr = value.end ? value.end.format(timeOnly) : 'end time';
          inputValue = "".concat(dateStr, ", ").concat(startTimeStr, " - ").concat(endTimeStr);
        }
      } else if (rangedDates) {
        var startDateStr = value.start ? value.start.format(displayFormat) : '';
        var endDateStr = value.end ? value.end.format(displayFormat) : '';
        if (startDateStr || endDateStr) inputValue = "".concat(startDateStr, " - ").concat(endDateStr);
      } else {
        inputValue = value ? value.format(displayFormat) : '';
      }

      return inputValue;
    });

    _defineProperty(_assertThisInitialized(_this), "viewPrevMonth", function () {
      _this.setState(function (state) {
        return {
          viewDate: (0, _moment["default"])(state.viewDate).subtract(1, 'months')
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "viewNextMonth", function () {
      _this.setState(function (state) {
        return {
          viewDate: (0, _moment["default"])(state.viewDate).add(1, 'months')
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleYearMenu", function () {
      _this.setState(function (state) {
        return {
          yearMenuOpen: !state.yearMenuOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "calculateYearMenuHeight", function () {
      var _this$props3 = _this.props,
          enableTimePicker = _this$props3.enableTimePicker,
          rangedTimes = _this$props3.rangedTimes;
      if (!enableTimePicker) return '301px';
      if (rangedTimes) return '417px';
      return '367px';
    });

    _defineProperty(_assertThisInitialized(_this), "selectYear", function (year) {
      _this.setState(function (state) {
        return {
          viewDate: (0, _moment["default"])(state.viewDate).year(year),
          yearMenuOpen: !state.yearMenuOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectSingleDate", function (e, selectedDate) {
      _this.setState({
        userIsTyping: false
      }); // eslint-disable-line react/no-unused-state


      var _this$state = _this.state,
          rangedStartDate = _this$state.rangedStartDate,
          rangedEndDate = _this$state.rangedEndDate;
      var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          rangedTimes = _this$props4.rangedTimes;
      var isoValue = '';
      var displayStr = '';

      if (rangedTimes) {
        var start = (0, _applyExistingTimes["default"])(rangedStartDate, selectedDate);
        var end = (0, _applyExistingTimes["default"])(rangedEndDate, selectedDate);
        isoValue = {
          start: start.toISOString(),
          end: end.toISOString()
        };
        displayStr = _this.getDisplayString({
          start: start,
          end: end
        });
      } else {
        isoValue = selectedDate.toISOString();
        displayStr = _this.getDisplayString(selectedDate);

        _this.closePicker();
      }

      onChange(e, isoValue, displayStr);
    });

    _defineProperty(_assertThisInitialized(_this), "selectRangedDate", function (e, selectedDate) {
      var onChange = _this.props.onChange;
      var _this$state2 = _this.state,
          rangedStartDate = _this$state2.rangedStartDate,
          rangedEndDate = _this$state2.rangedEndDate;
      var start;
      var end;

      if (!rangedStartDate || selectedDate.isBefore(rangedStartDate) || rangedEndDate) {
        start = selectedDate;
        end = null;
      }

      if (rangedStartDate && selectedDate.isAfter(rangedStartDate) && !rangedEndDate) {
        start = rangedStartDate;
        end = selectedDate;
      }

      var isoValue = {
        start: start ? start.toISOString() : '',
        end: end ? end.toISOString() : ''
      };

      var displayStr = _this.getDisplayString({
        start: start,
        end: end
      });

      onChange(e, isoValue, displayStr);
    });

    _defineProperty(_assertThisInitialized(_this), "selectTime", function (e, dateWithUpdatedTime, field) {
      var onChange = _this.props.onChange;
      var isoValue = '';
      var displayStr = '';

      if (field === 'nonRangeSelectedDate') {
        isoValue = dateWithUpdatedTime.toISOString();
        displayStr = _this.getDisplayString(dateWithUpdatedTime);
      } else {
        var _this$state3 = _this.state,
            rangedStartDate = _this$state3.rangedStartDate,
            rangedEndDate = _this$state3.rangedEndDate;
        var start = field === 'rangedStartDate' ? dateWithUpdatedTime : rangedStartDate;
        var end = field === 'rangedEndDate' ? dateWithUpdatedTime : rangedEndDate;
        isoValue = {
          start: start.toISOString(),
          end: end.toISOString()
        };
        displayStr = _this.getDisplayString({
          start: start,
          end: end
        });
      }

      onChange(e, isoValue, displayStr);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextInputChange", function (e, inputVal) {
      if (inputVal.includes('c')) {
        _this.clearDate(e);

        return;
      }

      var _this$props5 = _this.props,
          onChange = _this$props5.onChange,
          rangedDates = _this$props5.rangedDates,
          rangedTimes = _this$props5.rangedTimes;
      var formattedVal = inputVal; // auto-format if input val ends with 8 digits

      if (inputVal.length >= 8 && /^\d+$/.test(inputVal.slice(-8))) {
        var leadingStr = inputVal.slice(0, -8);
        var mm = inputVal.slice(-8, -6);
        var dd = inputVal.slice(-6, -4);
        var yyyy = inputVal.slice(-4);
        formattedVal = "".concat(leadingStr).concat(mm, "/").concat(dd, "/").concat(yyyy);
      } // auto-format connecting symbols for ranged inputs


      if (/^\d{2}\/\d{2}\/\d{4}$/.test(formattedVal)) {
        if (rangedDates) formattedVal += ' - ';
        if (rangedTimes) formattedVal += ', ';
      }

      _this.setState({
        userIsTyping: true,
        // eslint-disable-line react/no-unused-state
        textInputVal: formattedVal,
        isValid: true
      });

      onChange(e, formattedVal, inputVal);
    });

    _defineProperty(_assertThisInitialized(_this), "formatTextInput", function (e) {
      var inputVal = e.target.value;
      var _this$props6 = _this.props,
          rangedDates = _this$props6.rangedDates,
          rangedTimes = _this$props6.rangedTimes,
          onChange = _this$props6.onChange;

      var displayFormat = _this.getDisplayFormat();

      var callbackVal = inputVal;
      var displayStr = inputVal;

      if (rangedDates || rangedTimes) {
        var startStr = '';
        var endStr = '';

        if (rangedDates) {
          var _inputVal$split$map = inputVal.split('-').map(function (str) {
            return str.trim();
          });

          var _inputVal$split$map2 = _slicedToArray(_inputVal$split$map, 2);

          startStr = _inputVal$split$map2[0];
          endStr = _inputVal$split$map2[1];
        } else {
          var _inputVal$split$map3 = inputVal.split(',').map(function (str) {
            return str.trim();
          }),
              _inputVal$split$map4 = _slicedToArray(_inputVal$split$map3, 2),
              date = _inputVal$split$map4[0],
              times = _inputVal$split$map4[1];

          var _ref = times ? times.split('-').map(function (str) {
            return str.trim();
          }) : [],
              _ref2 = _slicedToArray(_ref, 2),
              startTime = _ref2[0],
              endTime = _ref2[1];

          startStr = date ? "".concat(date, ", ").concat(startTime) : '';
          endStr = date ? "".concat(date, ", ").concat(endTime) : '';
        }

        var start = (0, _moment["default"])(startStr, displayFormat, true);
        var end = (0, _moment["default"])(endStr, displayFormat, true);
        var startIsValid = start.isValid();
        var endIsValid = end.isValid();
        callbackVal = {
          start: startIsValid ? start.toISOString() : startStr,
          end: endIsValid ? end.toISOString() : endStr
        };
        if (startIsValid && endIsValid) displayStr = _this.getDisplayString({
          start: start,
          end: end
        });
      } else {
        var _date = (0, _moment["default"])(inputVal, displayFormat, true);

        var dateIsValid = _date.isValid();

        if (dateIsValid) {
          callbackVal = _date.toISOString();
          displayStr = _this.getDisplayString(_date);
        }
      }

      onChange(e, callbackVal, displayStr);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextInputBlur", function (e) {
      e.persist();
      var onBlur = _this.props.onBlur;

      _this.setState(function (_ref3) {
        var userIsTyping = _ref3.userIsTyping;
        if (!userIsTyping) return null;

        _this.formatTextInput(e);

        return {
          userIsTyping: false
        };
      }, function () {
        return onBlur(e);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleTextInputKeyDown", function (e) {
      var rangedDates = _this.props.rangedDates;
      var _this$state4 = _this.state,
          textInputVal = _this$state4.textInputVal,
          viewDate = _this$state4.viewDate; // esc

      if (e.keyCode === 27) {
        _this.closePicker();
      } // up arrow


      if (e.keyCode === 38) {
        _this.selectSingleDate(e, viewDate.add(1, 'day'));
      } // down arrow


      if (e.keyCode === 40) {
        _this.selectSingleDate(e, viewDate.subtract(1, 'day'));
      } // enter


      if (e.keyCode === 13) {
        if (!rangedDates && !textInputVal) {
          // select current day if input is empty
          _this.selectSingleDate(e, (0, _moment["default"])());
        } else {
          _this.formatTextInput(e);

          _this.closePicker();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearDate", function (e) {
      var _this$props7 = _this.props,
          onChange = _this$props7.onChange,
          rangedTimes = _this$props7.rangedTimes,
          rangedDates = _this$props7.rangedDates;
      var isRanged = rangedTimes || rangedDates;
      onChange(e, isRanged ? {
        start: '',
        end: ''
      } : '', '');

      _this.setState({
        viewDate: (0, _moment["default"])(),
        textInputVal: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openPicker", function () {
      var disabled = _this.props.disabled;
      if (disabled) return;

      _this.setState(function (state) {
        var selectedDate = state.nonRangeSelectedDate || state.rangedStartDate;
        var viewDate = state.isValid && selectedDate ? selectedDate : state.viewDate;
        return {
          pickerActive: true,
          yearMenuOpen: false,
          viewDate: viewDate
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePicker", function () {
      _this.setState({
        pickerActive: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickConfirm", function () {
      _this.closePicker();

      _this.props.onClickConfirm();
    });

    _this.state = {
      pickerActive: false,
      yearMenuOpen: false,
      // date determining user's current view (not necessarily selected)
      viewDate: (0, _moment["default"])(),
      // non-ranged, single date/time - selected value (not necessarily in view)
      nonRangeSelectedDate: null,
      // ranged dates and/or times - selected values
      rangedStartDate: null,
      rangedEndDate: null,
      // for TextInput
      userIsTyping: false,
      // eslint-disable-line react/no-unused-state
      textInputVal: '',
      isValid: true
    };
    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.populateState();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;
      if (!(0, _isEqual["default"])(prevProps.value, value)) this.populateState();
    }
  }, {
    key: "renderTextInput",
    value: function renderTextInput() {
      var _this$props8 = this.props,
          classes = _this$props8.classes,
          TargetComponent = _this$props8.TargetComponent,
          placeholder = _this$props8.placeholder,
          iconPlacement = _this$props8.iconPlacement,
          showError = _this$props8.showError,
          errorText = _this$props8.errorText,
          disabled = _this$props8.disabled,
          uncontained = _this$props8.uncontained,
          targetProps = _this$props8.targetProps;
      var _this$state5 = this.state,
          pickerActive = _this$state5.pickerActive,
          textInputVal = _this$state5.textInputVal,
          isValid = _this$state5.isValid;
      var calendarIconClassName = (0, _classnames["default"])(classes.calendarIcon, pickerActive ? classes.calendarIconActive : null, showError || !isValid ? classes.calendarIconInvalid : null);
      return _react["default"].createElement(TargetComponent, _extends({
        onClick: this.openPicker,
        placeholder: placeholder,
        rightIcon: iconPlacement === 'right' ? _react["default"].createElement(_icons.Calendar, {
          className: calendarIconClassName
        }) : null,
        leftIcon: iconPlacement === 'left' ? _react["default"].createElement(_icons.Calendar, {
          className: calendarIconClassName
        }) : null,
        value: textInputVal,
        onChange: this.handleTextInputChange,
        onBlur: this.handleTextInputBlur,
        onKeyDown: this.handleTextInputKeyDown,
        active: pickerActive,
        showError: showError || !isValid,
        errorText: errorText,
        disabled: disabled,
        uncontained: uncontained
      }, targetProps));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var classes = this.props.classes;
      var _this$state6 = this.state,
          yearMenuOpen = _this$state6.yearMenuOpen,
          viewDate = _this$state6.viewDate;
      return _react["default"].createElement("div", {
        className: classes.header
      }, _react["default"].createElement(_icons.PointerLeft, {
        className: classes.pointerArrow,
        onClick: this.viewPrevMonth
      }), _react["default"].createElement("div", {
        role: "presentation",
        className: classes.yearMenuToggler,
        onClick: this.toggleYearMenu
      }, _react["default"].createElement("span", null, viewDate.format(_displayFormats["default"].monthAndYear)), _react["default"].createElement(_icons.CaretDown, {
        className: (0, _classnames["default"])(classes.caret, yearMenuOpen ? classes.caretFlipped : null)
      })), _react["default"].createElement(_icons.PointerRight, {
        className: classes.pointerArrow,
        onClick: this.viewNextMonth
      }));
    }
  }, {
    key: "renderRangedDatesHeader",
    value: function renderRangedDatesHeader() {
      var classes = this.props.classes;
      var viewDate = this.state.viewDate;
      var nextMonthViewDate = (0, _moment["default"])(viewDate).add(1, 'month');
      return _react["default"].createElement("div", {
        className: classes.header
      }, _react["default"].createElement("div", {
        className: classes.rangedDatesHeaderHalf
      }, _react["default"].createElement(_icons.PointerLeft, {
        className: classes.pointerArrow,
        onClick: this.viewPrevMonth
      }), _react["default"].createElement("span", {
        className: classes.rangedDatesHeaderText
      }, viewDate.format('MMMM YYYY'))), _react["default"].createElement("div", {
        className: classes.rangedDatesHeaderHalf
      }, _react["default"].createElement("span", {
        className: classes.rangedDatesHeaderText
      }, nextMonthViewDate.format('MMMM YYYY')), _react["default"].createElement(_icons.PointerRight, {
        className: classes.pointerArrow,
        onClick: this.viewNextMonth
      })));
    }
  }, {
    key: "renderCalendars",
    value: function renderCalendars() {
      var _this$props9 = this.props,
          classes = _this$props9.classes,
          rangedDates = _this$props9.rangedDates,
          min = _this$props9.min,
          max = _this$props9.max;
      var _this$state7 = this.state,
          viewDate = _this$state7.viewDate,
          nonRangeSelectedDate = _this$state7.nonRangeSelectedDate,
          rangedStartDate = _this$state7.rangedStartDate,
          rangedEndDate = _this$state7.rangedEndDate;

      if (rangedDates) {
        return _react["default"].createElement("div", {
          className: classes.rangedCalendars
        }, _react["default"].createElement("div", {
          className: classes.rangedCalendarHalf
        }, _react["default"].createElement(_CalendarTable["default"], {
          viewMonthOnly: true,
          viewDate: viewDate,
          rangedStartDate: rangedStartDate,
          rangedEndDate: rangedEndDate,
          selectDate: this.selectRangedDate,
          min: min,
          max: max
        })), _react["default"].createElement("div", {
          className: classes.rangedCalendarHalf
        }, _react["default"].createElement(_CalendarTable["default"], {
          viewMonthOnly: true,
          viewDate: (0, _moment["default"])(viewDate).add(1, 'month'),
          rangedStartDate: rangedStartDate,
          rangedEndDate: rangedEndDate,
          selectDate: this.selectRangedDate,
          min: min,
          max: max
        })));
      }

      return _react["default"].createElement(_CalendarTable["default"], {
        viewDate: viewDate,
        nonRangeSelectedDate: nonRangeSelectedDate // single-date, single-time
        ,
        rangedStartDate: rangedStartDate // rangedTimes start
        ,
        rangedEndDate: rangedEndDate // rangedTimes end
        ,
        selectDate: this.selectSingleDate,
        min: min,
        max: max
      });
    }
  }, {
    key: "renderTimePickers",
    value: function renderTimePickers() {
      var _this2 = this;

      var _this$props10 = this.props,
          classes = _this$props10.classes,
          rangedTimes = _this$props10.rangedTimes,
          rangedDates = _this$props10.rangedDates;
      var _this$state8 = this.state,
          viewDate = _this$state8.viewDate,
          nonRangeSelectedDate = _this$state8.nonRangeSelectedDate,
          rangedStartDate = _this$state8.rangedStartDate,
          rangedEndDate = _this$state8.rangedEndDate;

      if (rangedTimes || rangedDates) {
        return _react["default"].createElement("div", {
          className: rangedDates ? classes.rangedDatesTimePickers : ''
        }, _react["default"].createElement(_TimePicker["default"], {
          label: rangedDates ? 'Start date time' : 'from',
          labelPosition: rangedDates ? 'top' : 'left',
          date: rangedStartDate || viewDate,
          selectTime: function selectTime() {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _this2.selectTime.apply(_this2, args.concat(['rangedStartDate']));
          }
        }), _react["default"].createElement(_TimePicker["default"], {
          label: rangedDates ? 'End date time' : 'to',
          labelPosition: rangedDates ? 'top' : 'left',
          date: rangedEndDate || viewDate,
          selectTime: function selectTime() {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            return _this2.selectTime.apply(_this2, args.concat(['rangedEndDate']));
          }
        }));
      }

      return _react["default"].createElement(_TimePicker["default"], {
        date: nonRangeSelectedDate || viewDate,
        selectTime: function selectTime() {
          for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            args[_key3] = arguments[_key3];
          }

          return _this2.selectTime.apply(_this2, args.concat(['nonRangeSelectedDate']));
        }
      });
    }
  }, {
    key: "renderMainPickerView",
    value: function renderMainPickerView() {
      var _this$props11 = this.props,
          classes = _this$props11.classes,
          enableTimePicker = _this$props11.enableTimePicker;
      var _this$state9 = this.state,
          nonRangeSelectedDate = _this$state9.nonRangeSelectedDate,
          rangedStartDate = _this$state9.rangedStartDate,
          rangedEndDate = _this$state9.rangedEndDate;
      var hasSelectedDate = nonRangeSelectedDate || rangedStartDate || rangedEndDate;
      return _react["default"].createElement("div", {
        className: classes.calendarView
      }, this.renderCalendars(), enableTimePicker && _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.timePickers, !hasSelectedDate ? classes.disableTimePickers : null)
      }, this.renderTimePickers()), _react["default"].createElement("div", {
        className: classes.actions
      }, _react["default"].createElement(_Button["default"], {
        type: "cancel",
        onClick: this.clearDate
      }, "Clear"), _react["default"].createElement(_Button["default"], {
        onClick: this.handleClickConfirm
      }, "Confirm")));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props12 = this.props,
          classes = _this$props12.classes,
          value = _this$props12.value,
          max = _this$props12.max,
          min = _this$props12.min,
          onChange = _this$props12.onChange,
          onBlur = _this$props12.onBlur,
          placeholder = _this$props12.placeholder,
          iconPlacement = _this$props12.iconPlacement,
          textInputVal = _this$props12.textInputVal,
          showError = _this$props12.showError,
          errorText = _this$props12.errorText,
          disabled = _this$props12.disabled,
          uncontained = _this$props12.uncontained,
          enableTimePicker = _this$props12.enableTimePicker,
          rangedTimes = _this$props12.rangedTimes,
          rangedDates = _this$props12.rangedDates,
          PopoverComponent = _this$props12.PopoverComponent,
          TargetComponent = _this$props12.TargetComponent,
          targetProps = _this$props12.targetProps,
          props = _objectWithoutProperties(_this$props12, ["classes", "value", "max", "min", "onChange", "onBlur", "placeholder", "iconPlacement", "textInputVal", "showError", "errorText", "disabled", "uncontained", "enableTimePicker", "rangedTimes", "rangedDates", "PopoverComponent", "TargetComponent", "targetProps"]);

      var _this$state10 = this.state,
          pickerActive = _this$state10.pickerActive,
          yearMenuOpen = _this$state10.yearMenuOpen,
          viewDate = _this$state10.viewDate;
      return _react["default"].createElement(PopoverComponent, {
        open: pickerActive,
        onRequestClose: this.closePicker,
        target: this.renderTextInput(),
        placement: iconPlacement === 'left' ? 'bottom-start' : 'bottom-end',
        uncontained: uncontained,
        popperProps: {
          uncontained: true,
          popperOptions: {
            positionFixed: true
          }
        },
        disableTransitions: true
      }, _react["default"].createElement("div", _extends({
        className: classes.root
      }, props), rangedDates ? this.renderRangedDatesHeader() : this.renderHeader(), yearMenuOpen ? _react["default"].createElement(_YearMenu["default"], {
        activeViewYear: viewDate.year(),
        selectYear: this.selectYear,
        height: this.calculateYearMenuHeight()
      }) : this.renderMainPickerView()));
    }
  }]);

  return DatePicker;
}(_react["default"].Component);

var datePropType = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]);

DatePicker.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Prop to set start amd end date, should be a string/object of start and end dates depending on if rangedTimes or rangedDates is true */
  value: _propTypes["default"].oneOfType([datePropType, _propTypes["default"].shape({
    start: datePropType,
    end: datePropType
  })]),

  /** Upper bound of allowed date selections */
  max: datePropType,

  /** Lower bound of allowed date selections */
  min: datePropType,

  /** onChange callback, Date values will always be ISO date strings, third arg will be the exact text thats shown in input */
  onChange: _propTypes["default"].func,

  /** onBlur callback of target component (default is TextInput) */
  onBlur: _propTypes["default"].func,

  /** A callback triggered when a user clicks the confirm button in the popover. Useful for reacting to date changes only when a user confirms them. */
  onClickConfirm: _propTypes["default"].func,

  /** Placeholder text of text input field */
  placeholder: _propTypes["default"].string,

  /** Whether to show error state of text input field */
  showError: _propTypes["default"].bool,

  /** Error text of text input field */
  errorText: _propTypes["default"].string,

  /** Disabled prop will be forwarded to target component, and picker will not open if true */
  disabled: _propTypes["default"].bool,

  /** Determines whether the calendar icon is placed on left or right of input field. Popper placement updates accordingly. */
  iconPlacement: _propTypes["default"].oneOf(['left', 'right']),

  /** For gridded forms */
  uncontained: _propTypes["default"].bool,

  /** Bool flag to show/hide the timepicker component */
  enableTimePicker: _propTypes["default"].bool,

  /** rangedTimes is only for single dates with ranged times. If rangedDates=true, the rangedTimes prop is ignored/not needed because a ranged date picker with enableTimePicker is, naturally, also going to have ranged times */
  rangedTimes: _propTypes["default"].bool,

  /** Bool flag to show/hide a range for picking dates i.e. start date and end date */
  rangedDates: _propTypes["default"].bool,

  /** Popover can be styled/configured as necessary. If supplied, the prop will be used in lieu of the default Popover */
  PopoverComponent: _propTypes["default"].func,

  /** Target component can be any custom component, although expected to be TextInput, it will receive the fol. props - placeholder, rightIcon, value, onChange, onBlur, active, showError, errorText */
  TargetComponent: _propTypes["default"].func,

  /** Forward any props to TargetComponent - whether that's the default TextInput or a custom component requiring specific props */
  targetProps: _propTypes["default"].objectOf(_propTypes["default"].any)
};
DatePicker.defaultProps = {
  PopoverComponent: _Popover["default"],
  TargetComponent: _TextInput["default"],
  disabled: false,
  enableTimePicker: false,
  errorText: 'Invalid value',
  iconPlacement: 'right',
  max: '',
  min: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onClickConfirm: function onClickConfirm() {},
  placeholder: '',
  rangedDates: false,
  rangedTimes: false,
  showError: false,
  targetProps: {},
  uncontained: false,
  value: null
};

var _default = (0, _withStyles["default"])(_styles["default"])(DatePicker);

exports["default"] = _default;